import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import markdown from '@opsbase/react-markdown';
import AddIcon from '@opsbase/web-icons/icons/AddIcon';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Vertical from '@opsbase/web-layout/Vertical';
import Link from '@opsbase/web-nav/Link';
import useNav from '@opsbase/web-nav/useNav';
import Text from '@opsbase/web-ui/Text';
import * as React from 'react';
export function NextSteps() {
    const { replaceTo } = useNav();
    return (React.createElement(Vertical, { gutter: true, paddingX: true },
        React.createElement(Text, { variant: 'h1' }, i18n.t('next-steps')),
        React.createElement(Text, null, i18n.t('next-steps-line1')),
        React.createElement(Text, { style: { marginTop: -8 } }, markdown(i18n.t('next-steps-line2'))),
        React.createElement(Text, null, i18n.t('next-steps-line3')),
        React.createElement(Link, { href: "#", onClick: () => replaceTo(Pages.OP_DEFINITIONS) },
            React.createElement(Horizontal, { gutter: true, justify: 'flex-start', centered: true },
                React.createElement(AddIcon, { fill: Palette.secondary.main }),
                i18n.t('add-more-ops'))),
        React.createElement(Link, { href: "#", onClick: () => replaceTo(Pages.PLACES) },
            React.createElement(Horizontal, { gutter: true, justify: 'flex-start', centered: true },
                React.createElement(AddIcon, { fill: Palette.secondary.main }),
                i18n.t('add-more-places'))),
        React.createElement(Link, { href: "#", onClick: () => replaceTo(Pages.TEAMS) },
            React.createElement(Horizontal, { gutter: true, justify: 'flex-start', centered: true },
                React.createElement(AddIcon, { fill: Palette.secondary.main }),
                i18n.t('add-more-teams'))),
        React.createElement(Link, { href: "#", onClick: () => replaceTo(Pages.POSITIONS) },
            React.createElement(Horizontal, { gutter: true, justify: 'flex-start', centered: true },
                React.createElement(AddIcon, { fill: Palette.secondary.main }),
                i18n.t('add-more-roles'))),
        React.createElement(Link, { href: "#", onClick: () => replaceTo(Pages.STAFF) },
            React.createElement(Horizontal, { gutter: true, justify: 'flex-start', centered: true },
                React.createElement(AddIcon, { fill: Palette.secondary.main }),
                i18n.t('add-your-staff')))));
}
export default NextSteps;
